// extracted by mini-css-extract-plugin
module.exports = {"root":"TopRelevantCategories-module__root___DlKlR","category":"TopRelevantCategories-module__category___GOBiW"};